import { ExportFormat } from "./listExport";

/**
 * Last file format chosen in a list export menu, shared by all lists so the user
 * picks Excel or CSV once. CSV is the default, as before Excel was offered.
 */

const STORAGE_KEY = 'listExportFormat';

export const getExportFormat = (): ExportFormat => {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'xlsx' ? 'xlsx' : 'csv';
    } catch {
        return 'csv';
    }
};

export const setExportFormat = (format: ExportFormat): void => {
    try {
        localStorage.setItem(STORAGE_KEY, format);
    } catch {
        // ignore storage errors (e.g. private mode)
    }
};
